<app-generic-search-bar
  [service]="complaintsService.incidentsService"
  [filterFields]="filterFields">
</app-generic-search-bar>

<div class="panel-body" style="background: none">
  <div class="row">
    <div class="col-md-12">
      <h3>Complaints</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <app-results-list
          [service]="complaintsService.incidentsService"
          [searchObj]="searchObj"
          [displayFields]="display_fields"
          (searchObjChange)="onSearchObjChange($event)">
      </app-results-list>
    </div>
  </div>
</div>
